<template>
    <div class="dashboard-calls">
        <div class="card-and-info-section">
            <!-- Primeira linha: 4 cards -->
            <div class="card-row">
                <div class="card-box-top card-received">
                    <div class="icon-box"><i class="fas fa-phone"></i></div>
                    <div class="card-text">
                        <h2>Recebidas</h2>
                        <p>{{ callsToday.incoming }}</p>
                    </div>
                </div>

                <div class="card-box-top card-answered">
                    <div class="icon-box"><i class="fas fa-phone-volume"></i></div>
                    <div class="card-text">
                        <h2>Atendidas</h2>
                        <p>{{ callsToday.answered }}</p>
                    </div>
                </div>

                <div class="card-box-top card-queue">
                    <div class="icon-box"><i class="fas fa-users"></i></div>
                    <div class="card-text">
                        <h2>Em fila</h2>
                        <p>{{ callsInQueue }}</p>
                    </div>
                </div>

                <div class="card-box-top card-attendance">
                    <div class="icon-box"><i class="fas fa-headset"></i></div>
                    <div class="card-text">
                        <h2>Em atendimento</h2>
                        <p>{{ callsInAttendance }}</p>
                    </div>
                </div>
            </div>

            <!-- Segunda linha: 5 cards -->
            <div class="card-row">
                <div class="card-box-top card-abandon">
                    <div class="icon-box"><i class="fas fa-phone-slash"></i></div>
                    <div class="card-text">
                        <h2>
                            Abandonadas
                            <span class="tooltip-container">
                                <i class="fa-solid fa-info-circle info-icon"></i>
                                <span class="tooltip-text">Abandonadas em mais de 30 segundos</span>
                            </span>
                        </h2>
                        <p>{{ callsToday.abandon }} ({{ abandonPercent }}%)</p>
                    </div>
                </div>

                <div class="card-box-top card-giveup">
                    <div class="icon-box"><i class="fas fa-user-slash"></i></div>
                    <div class="card-text">
                        <h2>
                            Desistentes
                            <span class="tooltip-container">
                                <i class="fa-solid fa-info-circle info-icon"></i>
                                <span class="tooltip-text">Abandonadas em menos de 30 segundos</span>
                            </span>
                        </h2>
                        <p>{{ callsToday.giveup }} ({{ giveupPercent }}%)</p>
                    </div>
                </div>

                <div class="card-box card-tma">
                    <div class="icon-box"><i class="fa-solid fa-clock"></i></div>
                    <div class="card-text">
                        <h2>
                            TMA
                            <span class="tooltip-container">
                                <i class="fa-solid fa-info-circle info-icon"></i>
                                <span class="tooltip-text">Tempo médio de atendimento</span>
                            </span>
                        </h2>
                        <p>{{ formatSeconds(tma) }}</p>
                    </div>
                </div>

                <div class="card-box card-tme">
                    <div class="icon-box"><i class="fa-solid fa-clock"></i></div>
                    <div class="card-text">
                        <h2>
                            TME
                            <span class="tooltip-container">
                                <i class="fa-solid fa-info-circle info-icon"></i>
                                <span class="tooltip-text">Tempo médio de espera</span>
                            </span>
                        </h2>
                        <p>{{ formatSeconds(tme) }}</p>
                    </div>
                </div>

                <div class="card-box card-service">
                    <div class="icon-box"><i class="fas fa-chart-bar"></i></div>
                    <div class="card-text">
                        <h2>
                            Nível de Serviço
                            <span class="tooltip-container">
                                <i class="fa-solid fa-info-circle info-icon"></i>
                                <span class="tooltip-text">Calculo do nivel de serviço:<br><br>Atendidas<br>--------------<br>(Recebidas - Desistentes)</span>
                            </span>
                        </h2>
                        <p>{{ serviceLevel }}%</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    props: {
        filter: { type: [Array, String], required: true },
        callsInQueue: { type: Number, default: 0 },
        callsInAttendance: { type: Number, default: 0 },
    },
    data() {
        return {
            callsToday: {
                incoming: 0,
                answered: 0,
                abandon: 0,
                giveup: 0,
            },
            serviceLevel: 0,
            tma: 0,
            tme: 0,
        };
    },
    computed: {
        abandonPercent() {
            return this.callsToday.incoming
                ? Math.round((this.callsToday.abandon * 100) / this.callsToday.incoming)
                : 0;
        },
        giveupPercent() {
            return this.callsToday.incoming
                ? Math.round((this.callsToday.giveup * 100) / this.callsToday.incoming)
                : 0;
        },
    },
    methods: {
        getCallsToday() {
            const queueParam =
                Array.isArray(this.filter) && this.filter.length > 0
                    ? this.filter.join(",")
                    : this.filter;

            axios
                .get(`${window.location.href}/todayCallsPerQueue?queue=${queueParam}`)
                .then(({ data }) => {
                    const denominator = data.incoming - data.giveup;
                    const percent = denominator > 0 ? (data.answered * 100) / denominator : 0;
                    this.callsToday = data;
                    this.serviceLevel = percent.toFixed(0);
                })
                .catch((e) => {
                    console.error("Erro ao buscar dados todayCallsPerQueue", e);
                });
        },
        getAverageTimes() {
            const queueParam =
                Array.isArray(this.filter) && this.filter.length > 0
                    ? this.filter.join(",")
                    : this.filter;

            axios
                .get(`${window.location.href}/averageWaitingTime?queue=${queueParam}`)
                .then(({ data }) => {
                    this.tme = data.length ? data.reduce((a, b) => a + b.average, 0) / data.length : 0;
                });

            axios
                .get(`${window.location.href}/averageServiceTime?queue=${queueParam}`)
                .then(({ data }) => {
                    this.tma = data.length ? data.reduce((a, b) => a + b.average, 0) / data.length : 0;
                });
        },
        formatSeconds(seconds) {
            return seconds >= 86400
                ? moment.duration(seconds, "seconds").format("hh:mm:ss")
                : moment.utc(seconds * 1000).format("HH:mm:ss");
        },
        refreshData() {
            this.getCallsToday();
            this.getAverageTimes();
        },
    },
    watch: {
        filter: {
            handler() {
                this.refreshData();
            },
            immediate: true,
        },
    },
};
</script>

<style scoped>
.dashboard-calls {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    padding-bottom: 40px;
    align-items: center;
}

.card-row {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
}

.card-box-top {
    display: flex;
    background-color: #f8f9fa;
    border-radius: 10px;
    padding: 15px 20px;
    flex: 1 1 440px;
    max-width: 440px;
    min-width: 440px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    gap: 16px;
}

/* Cards pequenos (últimos 3 da linha 2) */
.card-box {
    display: flex;
    background-color: #f8f9fa;
    border-radius: 10px;
    padding: 15px 20px;
    flex: 1 1 200px;
    max-width: 290px;
    min-width: 200px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    gap: 16px;
}

.icon-box {
    font-size: 28px;
    color: white;
    flex-shrink: 0;
}

.card-text {
    text-align: right;
    flex-grow: 1;
}

.card-text h2 {
    margin: 0;
    font-size: 14px;
    color: white;
}

.card-text p {
    margin: 0;
    font-size: 16px;
    font-weight: bold;
    color: white;
}

/* Cores específicas por tipo de card */
.card-received {
    background-color: #6c63ff;
}

.card-answered {
    background-color: #28a745;
}

.card-queue {
    background-color: #fabf57;
}

.card-attendance {
    background-color: #157cfc;
}

.card-abandon,
.card-giveup {
    background-color: #e64942;
}

.card-tma,
.card-tme,
.card-service {
    background-color: #0e3b64;
}

/* Tooltip estilizado */
.tooltip-container {
    position: relative;
    display: inline-block;
    margin-left: 6px;
    cursor: help;
}

.info-icon {
    font-size: 14px;
    color: #cbd5e1;
}

/* Tooltip text */
.tooltip-text {
    visibility: hidden;
    width: max-content;
    max-width: 180px;
    background-color: rgba(255, 255, 255, 0.9);
    color: #000000;
    font-weight: bold;
    text-align: center;
    border-radius: 6px;
    padding: 6px 10px;
    position: absolute;
    z-index: 1000;
    bottom: 125%;
    /* posiciona acima do ícone */
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.3s;
    font-size: 12px;
    line-height: 1.2;
    pointer-events: none;
    /* para não atrapalhar hover */
}

.tooltip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    /* seta embaixo da tooltip */
    left: 50%;
    margin-left: -6px;
    border-width: 6px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.9) transparent transparent transparent;
}

.tooltip-container:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
}

/* Estilos da nova seção de info */
.new-info-section {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 0;
}

.card-and-info-section {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* Painéis da nova seção */
.panel {
    background: white;
    border-radius: 10px;
    padding: 15px 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    flex: 1 1 320px;
    max-width: 380px;
}

/* Cabeçalhos */
.panel h3 {
    margin-top: 0;
    font-weight: 600;
    font-size: 16px;
    color: #333;
    margin-bottom: 12px;
}

/* Legenda do gráfico */
.legend-list {
    list-style: none;
    padding: 0;
    margin: 12px 0 0 0;
    font-size: 13px;
    color: #555;
}

.legend-list li {
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.legend-color {
    width: 14px;
    height: 14px;
    display: inline-block;
    border-radius: 3px;
}

.legend-color.available {
    background-color: #1EC200;
}

.legend-color.ringing {
    background-color: #FFC300;
}

.legend-color.busy {
    background-color: #337ab7;
}

.legend-color.pause {
    background-color: #FF7F50;
}

.legend-color.unreachable {
    background-color: #E64942;
}

/* Tabela de detalhes do agente */
.agent-details table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    color: #444;
}

.agent-details td {
    padding: 6px 8px;
    border-bottom: 1px solid #ddd;
}

.agent-details td:first-child {
    font-weight: 600;
    color: #333;
    width: 40%;
}

/* Tempo de espera */
.waiting-time {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #888;
    font-size: 14px;
    text-align: center;
    min-height: 170px;
}

.waiting-icon {
    font-size: 48px;
    margin-bottom: 10px;
    color: #bbb;
}
</style>